module.exports = __webpack_public_path__ + "assets/img/travel-day44.fe08da36.png";